var map = {
	"./tts_g1_0.mp3": "4d4e",
	"./tts_g1_1.mp3": "6250",
	"./tts_g1_2.mp3": "6563",
	"./tts_g1_3.mp3": "46d9",
	"./tts_g1_4.mp3": "89af",
	"./tts_g1_5.mp3": "227d",
	"./tts_g1_6.mp3": "999f",
	"./tts_g1_7.mp3": "50c1",
	"./tts_g1_8.mp3": "86be",
	"./tts_g1_9.mp3": "142a",
	"./tts_g1_a.mp3": "23fc",
	"./tts_g1_b.mp3": "013a",
	"./tts_g1_c.mp3": "2fa4",
	"./tts_g1_d.mp3": "dd23",
	"./tts_g1_dot.mp3": "c2e1",
	"./tts_g1_e.mp3": "da14",
	"./tts_g1_f.mp3": "4305",
	"./tts_g1_g.mp3": "33a5",
	"./tts_g1_h.mp3": "77e9",
	"./tts_g1_hao.mp3": "66f1",
	"./tts_g1_hundred.mp3": "1db1",
	"./tts_g1_i.mp3": "fcba",
	"./tts_g1_j.mp3": "65b1",
	"./tts_g1_qing.mp3": "5fbd",
	"./tts_g1_ten.mp3": "e409",
	"./tts_g1_thousand.mp3": "f43c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca73";